import { NO_PERMISSION_REQUIRED_ROUTES } from '../../constants'
import { useCcsLinks, useCrsLinks } from './links'

export const useUserHasRoutePermission = (route: string): boolean => {
  // Routes for which no permission are required are checked using regex
  const allowedRoutesRegexStr = `^(${NO_PERMISSION_REQUIRED_ROUTES.join('|')})$`
  const allowedRoutesRegex = new RegExp(allowedRoutesRegexStr)
  if (allowedRoutesRegex.test(route)) {
    return true
  }

  /**
   * Extract the base route
   * Ex: client is base route /client/client-settings
   * User with permission for /client will have permission for /client/*
   */
  const baseRoute = route.split('/')[1]
  const links = [...useCrsLinks(), ...useCcsLinks()]

  for (const link of links) {
    if (link.to === `/${baseRoute}`) return true
  }
  return false
}
